import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPreRequisito'
})
export class FormatPreRequisitoPipe implements PipeTransform {

  transform(value: string): unknown {
    if (!value) {
      return '';
    }

    // Ajusta o título
    let formattedText = value.replace(/^(.*?)\n/, '<p>$1</p>');

    // Converte os itens da lista em <li>
    formattedText = formattedText.replace(/\*\s+(.*?)(\n|$)/g, '<li>$1</li>');

    // Adiciona a tag <ul> ao redor dos itens da lista, se houver
    if (formattedText.includes('<li>')) {
      formattedText = formattedText.replace(/<li>/, '<ul>\n  <li>');
      formattedText += '\n</ul>';
    }

    return formattedText;
  }
}
